import { useEffect } from "react";
import { createPortal } from "react-dom";

/**
 * Modal — bullet-proof modal that renders into document.body via createPortal,
 * fully escaping any parent containing block / stacking context (backdrop-filter,
 * sticky elements, etc.). Tall content scrolls inside the backdrop using
 * items-start + py-8 so the modal header is always visible at the top.
 */
export default function Modal({ children, onClose, maxWidth = "max-w-md", testid }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    document.addEventListener("keydown", onKey);
    // Lock body scroll while modal open
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return createPortal(
    <div
      className="fixed inset-0 z-[100] bg-black/70 backdrop-blur flex items-start justify-center p-2 sm:p-4 py-4 sm:py-8 md:py-[6vh] overflow-y-auto"
      onClick={onClose}
      data-testid={testid ? `${testid}-backdrop` : undefined}
    >
      <div
        role="dialog"
        aria-modal="true"
        className={`noam-card w-full ${maxWidth} p-4 sm:p-6 my-auto max-h-[calc(100vh-2rem)] sm:max-h-[calc(100vh-4rem)] overflow-y-auto`}
        onClick={(e) => e.stopPropagation()}
        data-testid={testid}
      >
        {children}
      </div>
    </div>,
    document.body,
  );
}
